/* eslint-disable import/no-extraneous-dependencies */

/**
 * @memberof @albert-io/notifier
 * @memberof bugsnag
 */
import React from 'react';

import {Honeybadger} from '@honeybadger-io/react';

import bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import {getVersion, getEnvironment} from '@albert-io/environment';

import notifier from '../../notifier';
import configuration from './configuration';

const bugsnagApiKey = process.env.BUGSNAG_API_KEY_CLIENT;

const contentFilters = [
  'token',
  'email',
  'username',
  'password',
  'verify_old_password',
  'password_reset_link',
  'verify_password_reset_link',
  'stripe_customer_id',
  'first_name',
  'last_name',
  'salutation',
  'consent_email'
];

function onBugsnagError(event) {
  const user = notifier.getIdentity();
  // this will be useful for deciding what errors are from google translate
  const hasTranslate = global.document.getElementsByClassName('translated-ltr').length > 0;

  if (user && user.id) {
    event.setUser(user.id);
    event.addMetadata('authentication details', {...user, translate_enabled: hasTranslate});
  }
}

function startBugsnag() {
  bugsnag.start({
    ...configuration,
    apiKey: bugsnagApiKey,
    /**
     * Since we use the error boundary, we DO NOT let the library auto-detect
     * and send errors.
     */
    autoDetectErrors: false,
    onError: onBugsnagError,
    plugins: [new BugsnagPluginReact(React)]
  });
}

function startHoneybadger() {
  Honeybadger.configure({
    apiKey: process.env.HONEYBADGER_API_KEY,
    breadcrumbsEnabled: true,
    environment: getEnvironment(),
    filters: contentFilters,
    reportData: true,
    revision: getVersion()
  });

  // Set up beforeNotify handler
  Honeybadger.beforeNotify(function (notice) {
    const hasTranslate = global.document.getElementsByClassName('translated-ltr').length > 0;
    notice.context = {user: notifier.getIdentity(), hasTranslate};
  });
}

// eslint-disable-next-line import/no-mutable-exports
let BugsnagErrorBoundary = ({children}) => children;
if (process.env.IS_BROWSER && process.env.HONEYBADGER_API_KEY && bugsnagApiKey) {
  startBugsnag();
  startHoneybadger();
  notifier.setClient(bugsnag);
  BugsnagErrorBoundary = bugsnag.getPlugin('react');
  notifier.setNotifyHandler((error, context) => {
    // todo: Check if this needs to be replicated for honeybadger
    bugsnag.addMetadata({
      context
    });
    bugsnag.notify(error);

    Honeybadger.notify(error);
  });
}

export {BugsnagErrorBoundary};
export default notifier;
